(function () {
  const MERCHANT_ID = 'merchant_122PQOz1KWIWfFO4JaLOXafYWlmhv6B1Xo';
  const MODE_STR = (window.ALMA_API_MODE === 'LIVE') ? 'LIVE' : 'TEST';

  const almaLocaleMap = {
    fr: 'fr',
    en: 'en',
    es: 'es',
    it: 'it',
    de: 'de',
    nl: 'nl-NL',
    'nl-nl': 'nl-NL',
    'nl-be': 'nl-BE',
    pt: 'pt-PT',
    'pt-pt': 'pt-PT'
  };

  function init() {
    if (!window.Alma || !window.Alma.Widgets) return false;

    const widgetEl = document.querySelector('#alma-widget');
    if (!widgetEl) return true; // no widget on this page

    const amount = parseInt(widgetEl.dataset.almaAmount || '', 10);
    if (!Number.isFinite(amount) || amount <= 0) {
      widgetEl.innerHTML = '';
      return true;
    }

    const rawLocale = (widgetEl.dataset.almaLocale || 'en').toLowerCase();
    const locale = almaLocaleMap[rawLocale] || 'en';

    const widgets = Alma.Widgets.initialize(
      MERCHANT_ID,
      MODE_STR === 'LIVE' ? Alma.ApiMode.LIVE : Alma.ApiMode.TEST
    );

    function renderWidget(purchaseAmount) {
      const el = document.querySelector('#alma-widget');
      if (!el) return;

      el.innerHTML = '';

    widgets.add(Alma.Widgets.PaymentPlans, {
    container: '#alma-widget',
    purchaseAmount: amount,
    locale,
    hideIfNotEligible: true,
    monochrome: true,
    hideBorder: false,
    plans: [
        { installmentsCount: 2, minAmount: 5000, maxAmount: 200000 },
        { installmentsCount: 3, minAmount: 5000, maxAmount: 200000 }
    ]
    });

    }

    function setupOrUpdateModal(purchaseAmount) {
      // If the trigger doesn't exist, skip modal
      const trigger = document.querySelector('#alma-modal-trigger');
      if (!trigger) return;

      // Ensure clicking doesn’t jump the page
      trigger.addEventListener('click', function (e) { e.preventDefault(); }, { once: true });

      // Depending on Alma widget build, Modal can be added like other widgets.
      // We attach it to the trigger selector.
      // If your build uses a different API (open/close), tell me and I’ll adjust.
      widgets.add(Alma.Widgets.Modal, {
        clickableSelector: '#alma-modal-trigger',
        purchaseAmount,
        locale,
        // Modal can show multiple options even if PDP widget is single-plan:
        plans: [
          { installmentsCount: 2, minAmount: 5000, maxAmount: 200000 },
          { installmentsCount: 3, minAmount: 5000, maxAmount: 200000 }
        ]
      });
    }

    function renderAll(purchaseAmount) {
      renderWidget(purchaseAmount);
      setupOrUpdateModal(purchaseAmount);
    }

    // Initial render
    renderAll(amount);

    // Variant change
    document.addEventListener('variant:change', function (e) {
      const variant = e.detail && e.detail.variant;
      if (!variant) return;

      const el = document.querySelector('#alma-widget');
      if (!el) return;

      el.dataset.almaAmount = String(variant.price);
      renderAll(variant.price);
    });

    return true;
  }

  // Run now; retry briefly if Alma loads after your script
  if (init()) return;
  let tries = 0;
  const timer = setInterval(() => {
    tries += 1;
    if (init() || tries > 50) clearInterval(timer);
  }, 100);
})();
